export type SocialProvider = 'tiktok' | 'instagram' | 'google' | 'fake';

/**
 * Providers en los que se puede publicar contenido (subset de SocialProvider).
 * Google es solo identidad — no se publica.
 * `fake` es un provider mock para local/dev (ver featureFlags.ENABLE_FAKE_SOCIAL).
 */
export const PUBLISHABLE_PROVIDERS: SocialProvider[] = ['tiktok', 'instagram', 'fake'];
export const isPublishable = (p: SocialProvider): boolean => PUBLISHABLE_PROVIDERS.includes(p);

export interface SocialAccount {
  id: string;
  provider: SocialProvider;
  socialId: string;       // The provider's user ID (stable across sessions)
  username: string;       // Display name / handle
  avatarUrl?: string;
  connectedAt: string;    // ISO date string
  followerCount?: number; // From user.info.stats (TikTok) — shown in profile menu
  // From user.info.profile (TikTok). bio + verified badge surface in the
  // profile dropdown; tiktokHandle is the real @ handle (distinct from the
  // username field above which holds display_name).
  tiktokHandle?: string;
  bioDescription?: string;
  isVerified?: boolean;
  // Scopes OAuth que el usuario otorgó en TikTok (backend /accounts). Se usa para
  // detectar permisos faltantes y ofrecer reconectar (ver useProfileCompleteness).
  scopes?: string[];
  accessToken?: string;   // OAuth access token (sandbox only, no DB yet)
}
